import {Component, Input} from '@angular/core';
import {ListAmountItem} from '../../../../global';
import { NgIf, NgFor } from '@angular/common';
import { MessageComponent } from '../../message/message.component';
import { TranslatePipe } from '@ngx-translate/core';
import { CurrencyTransformPipe } from '../../../pipes/currency-transform.pipe';

@Component({
    selector: 'slm-table-amount',
    templateUrl: './table-amount.component.html',
    imports: [NgIf, NgFor, MessageComponent, TranslatePipe, CurrencyTransformPipe]
})
export class TableAmountComponent {
  @Input()
  public amounts: Array<ListAmountItem>;

  @Input()
  public sumAmount: ListAmountItem = null;

  @Input()
  public sumAmountLabel = 'ALL_AMOUNT_DEF_CURRENCY';

  @Input()
  public message: string;
}
